<template>
    <div>
        <div class="row page-titles hidden-sm-up">
            <div class="col-md-5 align-self-center">
                <h4 class="text-themecolor">New Program update</h4>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h4 class="card-title hidden-xs-down">New Program update</h4>
                <ul class="nav nav-tabs">
                    <li v-for="(item) in supportedLanguage" class="nav-item">
                        <a
                            class="nav-link"
                            :class="{ active: item.code === activeLang }"
                            data-toggle="tab"
                            :href="'#' + item.code"
                            @click="activeLang = item.code"
                        >{{ item.name }}</a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div
                        v-for="(item) in supportedLanguage"
                        :id="item.code"
                        class="tab-pane"
                        :class="{ active: item.code === activeLang }"
                    >
                        <div class="row mt-3">
                            <div class="col">
                                <div class="form-group">
                                    <label>Title *</label>
                                    <input
                                        v-model="title[item.code]"
                                        v-validate="item.code == 'et' ? 'required' : ''"
                                        type="text"
                                        :data-vv-name="'title_' + item.code"
                                        :data-vv-as="'title_' + item.code"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': errors.has('title_' + item.code)
                                        }"
                                    />
                                    <span
                                        v-show="errors.has('title_' + item.code)"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors.first('title_' + item.code) }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Intro</label>
                                    <quill-editor v-model="intro[item.code]" />
                                    <input
                                        v-model="intro[item.code]"
                                        v-validate="item.code == 'et' ? 'required' : ''"
                                        type="hidden"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': errors.has('intro_required_et') && item.code == 'et'
                                        }"
                                        data-vv-name="intro_required_et"
                                        data-vv-as="Intro"
                                    />
                                    <span
                                        v-show="errors.has('intro_required_et') && item.code == 'et'"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors.first('intro_required_et') }}</strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Body *</label>
                                    <quill-editor v-model="body[item.code]"></quill-editor>
                                    <input
                                        v-model="body[item.code]"
                                        v-validate="item.code == 'et' ? 'required' : ''"
                                        type="hidden"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': errors.has('body_required_et') && item.code == 'et'
                                        }"
                                        data-vv-name="body_required_et"
                                        data-vv-as="Body"
                                    />
                                    <span
                                        v-show="errors.has('body_required_et') && item.code == 'et'"
                                        class="invalid-feedback"
                                        role="alert"
                                    >
                                        <strong>{{ errors.first('body_required_et') }}</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <quill-custom-tags />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Tags</label>
                                    <div>
                                        <vue-tags-input
                                            v-model="tag"
                                            :tags="tags"
                                            :autocomplete-items="tagOptions"
                                            :add-only-from-autocomplete="true"
                                            @tags-changed="newTags => (tags = newTags)"
                                        ></vue-tags-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Date</label>
                                    <datepicker
                                        v-model="published_at"
                                        :monday-first="true"
                                        :clear-button="true"
                                        clear-button-icon="fa fa-close text-red"
                                        input-class="form-control bg-white"
                                        format="dd.MM.yyyy"
                                        :class="{ 'bg-white': true }"
                                    >
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Order</label>
                            <input
                                id="order_by"
                                v-model="form.order_by"
                                v-validate="'required|numeric'"
                                name="order_by"
                                type="number"
                                data-vv-name="order_by"
                                data-vv-as="order_by"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': errors.has('order_by')
                                }"
                            />
                            <span v-show="errors.has('order_by')" class="invalid-feedback" role="alert">
                                <strong>The Order field is required.</strong>
                            </span>
                        </div>
                        <div class="form-group">
                            <label>Header Photo</label><br />
                            <vue-base64-file-upload
                                accept="image/png,image/jpeg"
                                input-class="v1-image"
                                :disable-preview="true"
                                @file="getFileName"
                                @load="onImageLoad"
                            />
                        </div>
                        <img :src="form.img" style="width: 50%" />
                        <button type="button" class="btn btn-success" @click="store">
                            Save
                        </button>
                        <div class="form-group">
                            <label>Preview Photo</label><br />
                            <vue-base64-file-upload
                                accept="image/png,image/jpeg"
                                input-class="v1-image"
                                :disable-preview="true"
                                @file="getPreviewFileName"
                                @load="onPreviewImageLoad"
                            />
                        </div>
                        <img :src="form.preview_img" style="width: 50%" />
                        <button type="button" class="btn btn-success" @click="store">
                            Save
                        </button>
                        <div class="form-group">
                            <label>Countries</label>
                            <button class="btn btn-success btn-sm" @click="selectAllCountries">Select all</button>
                            <button class="btn btn-warning btn-sm" @click="deselectAllCountries">Remove all</button>
                            <v-select
                                v-model="country"
                                v-validate="'required'"
                                :options="countries"
                                label="name"
                                multiple
                                data-vv-name="country"
                                data-vv-as="country"
                                :class="{ 'custom-is-invalid': country_has_error }"
                                placeholder="- choose -"
                            >
                                <span slot="no-options">Nothing found</span>
                            </v-select>
                            <span v-if="country_has_error" class="invalid-feedback" role="alert">
                                <strong>Country is required</strong>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4>
                            Country Priorities
                            <button type="button" class="btn btn-success float-right" @click="addPriority">
                                Add Priority
                            </button>
                        </h4>
                        <div class="clearfix"></div>
                        <div v-for="(priority, i) in country_priorities" class="row mt-2">
                            <div class="col-md-6">
                                <label class="mb-2">Country</label>
                                <v-select
                                    v-model="priority.country_id"
                                    :options="countries"
                                    label="name"
                                    placeholder="- choose -"
                                >
                                    <span slot="no-options">Nothing found</span>
                                </v-select>
                            </div>
                            <div class="col-md-6">
                                <label>Priority</label>
                                <button
                                    type="button"
                                    class="btn btn-danger btn-sm float-right mb-1"
                                    @click="removePriority(i)"
                                >
                                    Remove Priority
                                </button>
                                <div class="clearfix"></div>
                                <input v-model="priority.priority" type="number" class="form-control" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import _ from 'lodash';

export default {
    data() {
        return {
            activeLang: 'et',
            country_priorities: [],
            title: {},
            intro: {},
            body: {},
            tag: '',
            tags: [],
            form: {},
            country: [],
            img_url: '',
            preview_img_url: '',
            intro_required_et: '',
            body_required_et: '',
            tagOptions: [{ text: 'News' }, { text: 'Food safety' }, { text: 'FoodDocs in media' }],
            countries: [],
            published_at: new Date(),
            supportedLanguage: []
        };
    },
    computed: {
        country_has_error() {
            return this.country && this.country.length == 0 ? true : false;
        }
    },
    created() {
        this.getSupportedFspConditionsLanguage();
        this.getCountries();
    },
    methods: {
        selectAllCountries() {
            this.country = [...this.countries];
        },
        deselectAllCountries() {
            this.country = [];
        },
        store() {
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    let updatedTags = [];
                    this.tags.forEach(tag => {
                        updatedTags.push(tag.text);
                    });
                    let country_id = _.uniqBy(this.country, function(e) {
                        return e.id;
                    });
                    country_id = country_id.map(obj => obj.id);

                    this.form = {
                        title: this.title,
                        intro: this.intro,
                        body: this.body,
                        tags: updatedTags,
                        img: this.form.img,
                        file_name: this.form.file_name,
                        preview_img: this.form.preview_img,
                        preview_file_name: this.form.preview_file_name,
                        country_id: country_id,
                        order_by: this.form.order_by,
                        published_at: this.published_at,
                        country_priorities: this.country_priorities
                    };
                    axios
                        .post('/api/superadmin/page-management/changelog', this.form)
                        .then(res => {
                            if (res.response && res.response.status == 403) {
                                this.$toastr.e('Access denied');
                                return false;
                            }
                            this.$toastr.i('Changelog saved');
                            this.$router.push({ name: 'pm.changelog' });
                        })
                        .catch(error => console.error(error));
                }
            });
        },
        addPriority() {
            let priority = { country_id: { name: 'Estonia', id: 63 }, priority: 1 };
            this.country_priorities.push(priority);
        },
        removePriority(index) {
            this.country_priorities.splice(index, 1);
        },
        getSupportedFspConditionsLanguage() {
            axios
                .get('/api/superadmin/food-safety-plan-conditions/languages')
                .then(res => {
                    this.supportedLanguage = res.data;
                })
                .catch(error => console.error(error));
        },
        countryChange(obj) {
            this.country_has_error = false;
            if (obj && obj.length == 0) {
                this.country_has_error = true;
                this.country = null;
                return null;
            } else {
                this.country_has_error = false;
            }
        },
        onImageLoad(dataUri) {
            Vue.set(this.form, 'img', dataUri);
        },
        onPreviewImageLoad(dataUri) {
            Vue.set(this.form, 'preview_img', dataUri);
        },
        getFileName(file) {
            Vue.set(this.form, 'file_name', file.name);
        },
        getPreviewFileName(file) {
            Vue.set(this.form, 'preview_file_name', file.name);
        },
        bodyChange({ text }, lang) {
            this.body[lang] = text;
        },
        getCountries() {
            axios
                .get('/api/classifiers/countries?simple-format=true')
                .then(res => {
                    let arr = [];
                    for (const item of res.data) {
                        arr = arr.concat(item.countries);
                    }
                    arr.sort((a, b) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }
                        return 0;
                    });
                    this.countries = arr;
                })
                .catch(error => console.error(error));
        }
    }
};
</script>
